import type { ReactNode } from "react";

const toneClasses: Record<string, string> = {
  gray: "bg-surface-raised text-gray-300 border border-surface-border",
  success: "bg-success-muted text-success",
  warning: "bg-warning-muted text-warning",
  danger: "bg-danger-muted text-danger",
  accent: "bg-accent-muted text-accent",
};

export function Badge({ children, tone = "gray" }: { children: ReactNode; tone?: keyof typeof toneClasses }) {
  return <span className={`badge ${toneClasses[tone]}`}>{children}</span>;
}
